import React from 'react';
import logoDodoTravel from '../../images/logoDodoTravel.png';
import whatsappLogo from '../../images/whatsappLogo.png';
import './DodoHeader.css';

const DodoHeader = () => {
  return (
    <div className="dodo-header">
      <div className="dodo-header__logo-col">
        <img className="dodo-header__logo" src={logoDodoTravel} alt="Dodo Travel" />
        <div className="dodo-header__phone">
          <img className="dodo-header__wa-icon" src={whatsappLogo} alt="WhatsApp" />
          <span>3513719249</span>
        </div>
      </div>
      <div className="dodo-header__company">
        <div className="dodo-header__company-name">DODO TRAVEL</div>
        <div>DOTRAR SAS</div>
        <div>LEGAJO: 20223</div>
        <div>IVA: RESPONSABLE INSCRIPTO</div>
        <div>CUIT: 30 71903887 1</div>
      </div>
    </div>
  );
};

export default DodoHeader;
